<template>
  <v-card flat :outlined="!isMobile()" rounded="lg">
    <v-card-title class="subtitle-1" :class="{ 'pl-0 pt-0': isMobile() }">
      <span :class="{ 'text-center': isMobile() }">
        A <b>COASUL</b> estará abrindo vagas para <b>“Aprendiz Industrial”</b>,
        no curso de
        <b>“Operador de Processos de Produção de Carnes e Derivados”</b>. O
        curso de aprendizagem é composto por atividades teóricas e práticas, que
        serão realizadas no Abatedouro de Aves da COASUL em São João.</span
      >
    </v-card-title>
    <v-card-text class="pb-2 mb-3" :class="{ 'pl-0 pr-0': isMobile() }">
      <v-row :dense="isMobile()">
        <v-col xl="6" lg="6" md="6" sm="12" align-self="center">
          <v-dialog v-model="dialog" max-width="700" scrollable>
            <template v-slot:activator="{ on, attrs }">
              <v-alert
                type="info"
                text
                icon="mdi-gesture-tap-button"
                v-on="on"
                v-bind="attrs"
                border="left"
                prominent
              >
                Clique aqui para saber mais sobre o curso
              </v-alert>
            </template>
            <v-card>
              <v-card-title
                class="green lighten-4 green--text text--darken-4 font-weight-bold"
                >Como Será o Curso ?</v-card-title
              >
              <v-card-text class="subtitle-1 pt-6">
                <p>
                  Duração: <br />
                  <b>12 meses</b>
                </p>
                <p>
                  Carga horária total: <br />
                  <b>560 horas (224 horas teóricas + 336 horas práticas)</b>
                </p>
                <p>
                  Carga horária semanal: <br />
                  <b>40 horas</b>
                </p>
                <p>
                  Salário: <br />
                  <b>R$ 1.412,00</b>
                </p>
                <p>
                  Idade dos aprendizes: <br />
                  <b>18 a 22 anos</b>
                </p>
                <p>
                  Escolaridade: <br />
                  <b>
                    Estar cursando Ensino Fundamental ou Médio, ou ter concluído
                    o Ensino Médio.</b
                  >
                </p>
                <p>
                  Previsão de início da turma: <br />
                  <b>março/2024</b>
                </p>
                <p>
                  Local do curso: <br />
                  <b>Abatedouro de Aves da Coasul – São João, PR</b>
                </p>
              </v-card-text>
              <v-card-actions class="pa-0">
                <v-btn @click="dialog = false" large block tile>Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col xl="6" lg="6" md="6" sm="12" align-self="center">
          <v-alert color="warning" text icon="mdi-bus" border="left" prominent>
            Temos vagas disponíveis para todas as cidades onde há transporte
            para o Abatedouro.
          </v-alert>
        </v-col>
      </v-row>
      <v-row class="subtitle-1 black--text" dense>
        <v-col cols="12" :class="{ 'text-center': isMobile() }">
          Ficou interessado(a) em fazer parte da nossa cooperativa? Inscreva-se
          através do link abaixo, marcando no campo
          <b>“Áreas de Interesse”</b> a opção <b>“Aprendiz Industrial”</b>.
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-alert icon="mdi-calendar" color="grey lighten-4"
            >Fique atento, as inscrições podem ser feitas até dia
            <b>25/02/2024</b></v-alert
          >
        </v-col>
      </v-row>
      <v-row dense class="subtitle-1 black--text">
        <v-col cols="12" :class="{ 'text-center': isMobile() }">
          Se tiver dúvidas, fale conosco através do whatsapp
          <v-btn
            class="ml-1"
            color="teal"
            rounded
            @click="abrirWhatsapp()"
            dark
            small
            depressed
            text
            ><v-icon left>mdi-whatsapp</v-icon>+55 4635338100</v-btn
          >
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    dialog: false,
  }),
  methods: {
    ...mapActions(["abrirWhatsapp"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>